const values = {
    "ARTICLES": "Articles"
}

export default values;